import { render, staticRenderFns } from "./orderMagtDetail.vue?vue&type=template&id=409c470d"
import script from "./orderMagtDetail.vue?vue&type=script&lang=js"
export * from "./orderMagtDetail.vue?vue&type=script&lang=js"
import style0 from "./orderMagtDetail.vue?vue&type=style&index=0&id=409c470d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports